var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLoading
    ? _c("div", [
        _c("div", { staticClass: "select is-small is-fullwidth" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.serieDocumentalSeleccionado,
                  expression: "serieDocumentalSeleccionado",
                },
              ],
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.serieDocumentalSeleccionado = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { domProps: { value: null } }, [
                _vm._v("- Desactivado -"),
              ]),
              _vm._v(" "),
              _vm._l(_vm.seriesDoc, function (serie) {
                return _c(
                  "option",
                  { key: serie.id, domProps: { value: serie } },
                  [_vm._v(_vm._s(serie.nombre))]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _vm.estados
          ? _c("div", [
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "select is-small is-fullwidth" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.estadoSeleccionado,
                        expression: "estadoSeleccionado",
                      },
                    ],
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.estadoSeleccionado = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v("- Cualquier estado -"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.estados, function (e, key) {
                      return _c(
                        "option",
                        { key: key, domProps: { value: key } },
                        [_vm._v(_vm._s(e))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _c("div", [
        _c("div", { staticClass: "select is-small is-fullwidth" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.serieDocumentalSeleccionado,
                  expression: "serieDocumentalSeleccionado",
                },
              ],
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.serieDocumentalSeleccionado = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { domProps: { value: null } }, [
                _vm._v("Cargando..."),
              ]),
            ]
          ),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }